export const getAccessoryInstallationKey = (key: string = "0"): "no" | "yes" =>
  Number(key || 0) ? "yes" : "no";
